exports.unitList = [
  { id: 3, u_name: "Pcs" },
  { id: 4, u_name: "Pkt" },
  { id: 5, u_name: "Inch" },
  { id: 10, u_name: "sft" },
  { id: 13, u_name: "Bundle" },
  { id: 14, u_name: "Meter" },
];

exports.bankList = [
  { id: 1, name: "Agrani Bank" },
  { id: 2, name: "Janata Bank" },
  { id: 3, name: "Sonali Bank" },
  { id: 4, name: "Rupali Bank" },
  { id: 5, name: "Bangladesh Krishi Bank" },
  { id: 6, name: "Probashi Kallyan Bank" },
  { id: 7, name: "AB Bank PLC" },
  { id: 8, name: "Bangladesh Commerce Bank Limited" },
  { id: 9, name: "Bank Asia PLC" },
  { id: 10, name: "Bengal Commercial Bank Limited" },
  { id: 11, name: "BRAC Bank PLC" },
  { id: 12, name: "City Bank PLC" },
  { id: 13, name: "Community Bank Bangladesh PLC" },
  { id: 14, name: "Dhaka Bank PLC" },
  { id: 15, name: "Dutch-Bangla Bank PLC" },
  { id: 16, name: "Eastern Bank PLC" },
  { id: 17, name: "IFIC Bank PLC" },
  { id: 18, name: "Jamuna Bank Limited" },
  { id: 19, name: "Meghna Bank PLC" },
  { id: 20, name: "Mercantile Bank PLC" },
  { id: 21, name: "Midland Bank Limited" },
  { id: 22, name: "Mutual Trust Bank PLC" },
  { id: 23, name: "NRB Bank Limited" },
  { id: 24, name: "NRBC Bank PLC" },
  { id: 25, name: "ONE Bank PLC" },
  { id: 26, name: "Premier Bank PLC" },
  { id: 27, name: "Prime Bank PLC" },
  { id: 28, name: "Pubali Bank PLC" },
  { id: 29, name: "Shimanto Bank Limited" },
  { id: 30, name: "Southeast Bank Limited" },
  { id: 31, name: "Trust Bank PLC" },
  { id: 32, name: "United Commercial Bank PLC" },
  { id: 33, name: "Uttara Bank PLC" },
  { id: 34, name: "Exim Bank PLC" },
  { id: 35, name: "Al-Arafah Islami Bank PLC" },
  { id: 36, name: "First Security Islami Bank PLC" },
  { id: 37, name: "Global Islami Bank PLC" },
  { id: 38, name: "ICB Islamic Bank PLC" },
  { id: 39, name: "Islami Bank Bangladesh PLC" },
  { id: 40, name: "Shahjalal Islami Bank PLC" },
  { id: 41, name: "Social Islami Bank PLC" },
  { id: 42, name: "Standard Bank PLC" },
  { id: 43, name: "Union Bank PLC" },
  { id: 44, name: "Bank Al-Falah Limited" },
  { id: 45, name: "Grameen Bank" },
];
